import React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'

import App from './App'
import AppState from './AppState'

Sentry.init({
    release: process.env.RELEASE,
    dsn: 'https://c5465a11982f3c34f6c0731772696dfd@o4508958894850048.ingest.de.sentry.io/4508958896160848',
    environment: process.env.SENTRY_ENV,
    integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
})

const store = new AppState()
const root = createRoot(document.getElementById('surveyBuilder'))
root.render(<App store={store} />)
